// GET
export const REQUEST_LIST_OF_PARTNER_DIRECTORY =
  'REQUEST_LIST_OF_PARTNER_DIRECTORY';
export const RECEIVE_LIST_OF_PARTNER_DIRECTORY =
  'RECEIVE_LIST_OF_PARTNER_DIRECTORY';
export const LIST_OF_PARTNER_DIRECTORY_ERROR =
  'LIST_OF_PARTNER_DIRECTORY_ERROR';

// POST
export const REQUEST_ADD_PARTNER_TO_DIRECTORY =
  'REQUEST_ADD_PARTNER_TO_DIRECTORY';
export const RECEIVE_ADD_PARTNER_TO_DIRECTORY =
  'RECEIVE_ADD_PARTNER_TO_DIRECTORY';
export const ADD_PARTNER_TO_DIRECTORY_ERROR = 'ADD_PARTNER_TO_DIRECTORY_ERROR';

// PATCH
export const REQUEST_UPDATE_PARTNER_TO_DIRECTORY =
  'REQUEST_UPDATE_PARTNER_TO_DIRECTORY';
export const RECEIVE_UPDATE_PARTNER_TO_DIRECTORY =
  'RECEIVE_UPDATE_PARTNER_TO_DIRECTORY';
export const UPDATE_PARTNER_TO_DIRECTORY_ERROR =
  'UPDATE_PARTNER_TO_DIRECTORY_ERROR';

// DELETE
export const REQUEST_DELETE_PARTNER_FROM_DIRECTORY =
  'REQUEST_DELETE_PARTNER_FROM_DIRECTORY';
export const RECEIVE_DELETE_PARTNER_FROM_DIRECTORY =
  'RECEIVE_DELETE_PARTNER_FROM_DIRECTORY';
export const DELETE_PARTNER_FROM_DIRECTORY_ERROR =
  'DELETE_PARTNER_FROM_DIRECTORY_ERROR';

// GET
export const REQUEST_PARTNER_DIRECTORY_DETAILS =
  'REQUEST_PARTNER_DIRECTORY_DETAILS';
export const RECEIVE_PARTNER_DIRECTORY_DETAILS =
  'RECEIVE_PARTNER_DIRECTORY_DETAILS';
export const PARTNER_DIRECTORY_DETAILS_ERROR =
  'PARTNER_DIRECTORY_DETAILS_ERROR';
